// Single source of truth for the languages a therapist can speak.
// Must match the `languages` table seeded by migration-languages.sql.
//
// This file exists for the same reason constants/specialisations.js does:
// the same list was almost hardcoded separately in home.jsx and the admin
// tool, which is exactly how the specialisation categories drifted out of
// sync with the database in the first place. Add a new language here AND
// in migration-languages.sql — never in just one place.
export const LANGUAGES = [
  'Assamese',
  'Bengali',
  'Bodo',
  'Mizo',
  'Hindi',
  'English',
  'Nepali',
  'Manipuri',
];